import React, { useEffect } from "react";
import SalePackages from "../../SalePackagesBlock/SalePackages";
import { connect } from "react-redux";
import { setSelectedPackage } from "../familyMemberCellularSaleSlice";
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
const FamilyMemberCellularSalePackages = (props) => {


  const onSelectedPackages = (selectedPackage) => {
    if (selectedPackage !== props.store.selectedPackage) {
      props.setSelectedPackage(
        props.cellularPackageList?.expandedValue?.[selectedPackage],
      );
    }
  };

  return (
    <div className="org-family-members-sale-package-wrapper">
        <div className="sale-package-wrapper">
                <h2 className="sale-package-title">בחרו את התוכנית המושלמת בשבילכם</h2>
                <SalePackages
                packages={props.cellularPackageList}
                isSwiper={true}
                isHideButton={true}
                onSelectedPackages={onSelectedPackages}
                isOrgPlan={true}
                />
        </div>
        <div className="button-packages-wrapper">
            <BtnSubmit
              className={props.store.selectedPackage?"":"grayBtn"} 
              text={"אישור והמשך"} 
              onclick={() => {
              if (props.store?.selectedPackage) {
                  props.context.navigateTo(props.store?.selectedPackage?.link?.value);
              }
              }}/>
        </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.familyMemberCellularSale,
  };
};

const mapDispatchToProps = {
  setSelectedPackage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FamilyMemberCellularSalePackages);
